import { ControllerRenderProps, MultiSelect } from '@otp/ui';
import { useMemo } from 'react';
import { TagEntityType } from 'src/graphql/generated/graphql';
import { useTags } from 'src/hooks/query/use-tags';

type TagsProps = {
  field: ControllerRenderProps<any, any>;
  entityType: TagEntityType;
  className?: string;
};

export const TagsField = ({ field, entityType, className }: TagsProps) => {
  const { tags } = useTags({ filter: { entityType } });

  const tagOptions = useMemo(
    () =>
      tags.map((tag) => ({
        value: tag.id,
        name: tag.name,
      })),
    [tags],
  );

  if (!tagOptions.length) {
    return null;
  }

  const defaultTagValue = field.value;

  return (
    <MultiSelect
      key={field.value}
      multiple={true}
      fullWidth={true}
      className={className}
      options={tagOptions}
      defaultValue={defaultTagValue}
      {...field}
      value={undefined}
      ref={undefined}
    />
  );
};
